import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const BackButton = ({ className = '', label = 'Back', to = null }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    // Priority 1: Explicit 'to' prop
    if (to) {
      navigate(to);
      return;
    }

    // Priority 2: 'from' in location state (where we came from)
    if (location.state?.from) {
      navigate(location.state.from);
      return;
    }

    // Priority 3: returnUrl in location state (legacy support)
    if (location.state?.returnUrl) {
      navigate(location.state.returnUrl);
      return;
    }

    // Priority 4: Intelligent fallback based on current path
    const path = location.pathname;
    
    // Admin pages
    if (path.startsWith('/admin/')) {
      if (path.includes('/users/')) {
        navigate('/admin/users'); // User detail → users list
      } else {
        navigate('/admin'); // Any other admin page → dashboard
      }
      return;
    }

    // User pages
    if (path === '/verification') {
      navigate('/profile'); // Verification → profile
    } else if (path.startsWith('/chat/')) {
      navigate('/connections'); // Chat → connections
    } else if (path === '/connections' || path === '/shortlist' || path === '/search') {
      navigate('/'); // List pages → home
    } else {
      // Default: go to home
      navigate('/');
    }
  };

  return (
    <button
      onClick={handleBack}
      className={`flex items-center text-gray-700 hover:text-navy-500 transition-colors mb-4 touch-manipulation ${className}`}
      type="button"
    >
      <ArrowLeft className="w-5 h-5 mr-2" />
      <span className="font-medium">{label}</span>
    </button>
  );
};

export default BackButton;
